import { types } from '../reducers/vodOutputsReducer';

// eslint-disable-next-line import/prefer-default-export
export const createVodOutputs = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateVodOutputs = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeVodOutputs = (item) => ({
  type: types.DELETE,
  payload: item,
});

export const reloadVodOutputs = (items) => ({
  type: types.RELOAD,
  payload: items,
});


export const resetVodOutputs = () => ({
  type: types.RESET,
});


export { getDraftId } from '../reducers/vodOutputsReducer';
